import React from "react";

function Text(props) {
  const { variant, html, children, className } = props;
  const componentsMap = {
    body: "div",
    h1: "h1",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
  };

  const Component = componentsMap[variant];

  const htmlContentProps = html
    ? {
        dangerouslySetInnerHTML: { __html: html },
      }
    : {};
  return (
    <>
      <Component {...htmlContentProps} className={className}>
        {children}
      </Component>
    </>
  );
}

export default Text;
